"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Slider = void 0;
const cash_dom_1 = __importDefault(require("cash-dom"));
class Slider {
    constructor(element) {
        // config
        this.maxVisible = 9;
        // elements
        this.element = null;
        this.slideInner = null;
        this.scroller = null;
        this.slides = [];
        this.skipper = null;
        this.skipperRev = null;
        this.slider_count = 0;
        this.slider_width = 0;
        this.slider_visible = 0;
        this.scrollCount = 0;
        this.indicator = null;
        this.indicatorItems = null;
        this.indicatorHidden = false;
        this.init = () => {
            // any slides?
            if (!this.slides || this.slides.length == 0) {
                return;
            }
            this.slider_count = this.slides.length;
            (0, cash_dom_1.default)(this.slides).each((slide_index) => {
                var _a;
                const target = (_a = (0, cash_dom_1.default)(this.slides[slide_index]).attr('data-target')) !== null && _a !== void 0 ? _a : '';
                if (target) {
                    (0, cash_dom_1.default)(this.slides[slide_index]).addClass('pointer');
                    (0, cash_dom_1.default)(this.slides[slide_index]).on('click', () => {
                        window.open(target, '_self');
                    });
                }
            });
            // need to scroll?
            if (this.element.width() >= (0, cash_dom_1.default)('.sliderInner .scroller', this.element).width()) {
                return;
            }
            // indicator visible
            //this.indicatorHidden = (this.indicator && this.indicator[0]) ? window.getComputedStyle(this.indicator[0]).display == 'none' : true;
            this.indicatorHidden = (this.indicator && this.indicator[0]) ? (document.body.clientWidth > 768) : true;
            let first_element = (0, cash_dom_1.default)(this.slides[0]);
            this.slider_width = (0, cash_dom_1.default)(this.slides[0]).width() + parseFloat(first_element.css('margin-right'));
            // get visible slider
            this.slider_visible = Math.floor(this.element.width() / this.slider_width);
            //this.indicatorHidden && this.skipper.show();
            if (this.indicatorHidden && this.slides.length > this.slider_visible) {
                this.skipper.show();
            }
            this.skipper.on('click', (event) => {
                const newIndex = this.scrollCount + this.slider_visible;
                if (newIndex + this.slider_visible >= this.slides.length && this.scrollCount != 0) {
                    (0, cash_dom_1.default)('.sliderIconNext', this.skipper).hide();
                    (0, cash_dom_1.default)('.sliderIconRev', this.skipper).show();
                }
                else {
                    (0, cash_dom_1.default)('.sliderIconRev', this.skipper).hide();
                    (0, cash_dom_1.default)('.sliderIconNext', this.skipper).show();
                }
                this.scrollToPosition(newIndex);
            });
            this.slideInner.on('scroll', (event) => {
                //console.log(this.element.offset(), this.scroller.offset());
                let slider_inner = (0, cash_dom_1.default)('.sliderInner', this.element);
                if (this.element.offset().left > slider_inner.offset().left) {
                    this.indicatorHidden && this.skipper.hide();
                }
                else {
                    this.indicatorHidden && this.skipper.show();
                }
            });
            this.initIndicator();
        };
        this.initIndicator = () => {
            if (!this.indicatorItems) {
                return;
            }
            if (this.indicatorItems.length > this.maxVisible * this.slider_visible) {
                this.indicator.addClass('oversize');
                this.updateIndicatorOversize();
            }
            this.indicatorItems.each((i, element) => {
                const index = (0, cash_dom_1.default)(element).attr('data-index');
                (0, cash_dom_1.default)(element).on('click', () => {
                    this.scrollToPosition(i);
                    this.updateIndicatorOversize();
                });
            });
        };
        this.updateIndicatorOversize = () => {
            this.indicatorItems.removeClass('prev');
            this.indicatorItems.removeClass('prev-1');
            this.indicatorItems.removeClass('next');
            this.indicatorItems.removeClass('next-1');
            let iPrev1 = this.scrollCount - this.slider_visible;
            let iPrev2 = this.scrollCount - 2 * this.slider_visible;
            let iNext1 = this.scrollCount + this.slider_visible;
            let iNext2 = this.scrollCount + 2 * this.slider_visible;
            if (iPrev1 > 1 && iNext1 < this.indicatorItems.length) {
                (0, cash_dom_1.default)(this.indicatorItems[iPrev1]).addClass('prev');
                (0, cash_dom_1.default)(this.indicatorItems[iNext1]).addClass('next');
            }
            else if (iPrev1 > 1 && iPrev2 > 1) {
                (0, cash_dom_1.default)(this.indicatorItems[iPrev1]).addClass('prev-1');
                (0, cash_dom_1.default)(this.indicatorItems[iPrev2]).addClass('prev');
            }
            else if (iNext1 < this.indicatorItems.length && iNext2 < this.indicatorItems.length) {
                (0, cash_dom_1.default)(this.indicatorItems[iNext1]).addClass('next-1');
                (0, cash_dom_1.default)(this.indicatorItems[iNext2]).addClass('next');
            }
            else {
                console.log(this.scrollCount, this.slider_visible);
            }
        };
        this.scrollToPosition = (index) => {
            this.scrollCount = index;
            let scrollTo = (this.slider_width * (this.scrollCount));
            if (this.scrollCount >= this.slides.length) {
                scrollTo = 0;
                this.scrollCount = 0;
                (0, cash_dom_1.default)('.sliderIconRev', this.skipper).hide();
                (0, cash_dom_1.default)('.sliderIconNext', this.skipper).show();
            }
            //console.log(index, this.scrollCount, scrollTo)
            this.slideInner[0].scrollTo({
                left: scrollTo,
                behavior: 'smooth'
            });
            (0, cash_dom_1.default)('.indicator', this.indicator).removeClass('active');
            (0, cash_dom_1.default)('.indicator', this.indicator).filter((i) => i == this.scrollCount).addClass('active');
        };
        this.checkSize = () => {
        };
        this.element = element;
        this.slideInner = (0, cash_dom_1.default)('.sliderInner', element);
        this.scroller = (0, cash_dom_1.default)('.scroller', element);
        this.slides = (0, cash_dom_1.default)('.card', element);
        this.skipper = (0, cash_dom_1.default)('.sliderNext', element);
        this.skipperRev = (0, cash_dom_1.default)('.siliderRev', element);
        this.indicator = (0, cash_dom_1.default)('.indicator-container', element);
        this.indicatorItems = (0, cash_dom_1.default)('.indicator', this.indicator);
        this.init();
        // $('window').on('resize', (event) => {
        window.onresize = () => {
            this.init();
        };
    }
}
exports.Slider = Slider;
